import { DefaultMetricOptions, MetricTemplate } from '@griply/types';

// Offline fallback for Remote Config's `goalMetricTemplates`, the authoritative list; keep its baseline entries in sync.
export const DEFAULT_METRIC_TEMPLATES: MetricTemplate[] = [
  {
    id: DefaultMetricOptions.CompletedTasks,
    name: {
      en: 'Completed tasks',
      nl: 'Voltooide taken',
    },
    description: {
      en: 'E.g 5/10 tasks completed = 50%',
      nl: 'Bijvoorbeeld 5/10 taken voltooid = 50%',
    },
    descriptionShort: {
      en: '5/10 tasks = 50%',
      nl: '5/10 taken = 50%',
    },
    unitName: {
      en: 'Tasks',
      nl: 'Taken',
    },
  },
  {
    id: DefaultMetricOptions.SubGoalProgress,
    name: {
      en: 'Subgoal progress',
      nl: 'Subdoel voortgang',
    },
    description: {
      en: 'E.g 1/4 subgoals at 100% = 25%',
      nl: 'Bijvoorbeeld 1/4 subdoelen op 100% = 25%',
    },
    descriptionShort: {
      en: '1/4 subgoals = 25%',
      nl: '1/4 subdoelen = 25%',
    },
    unitName: {
      en: 'Subgoals',
      nl: 'Subdoelen',
    },
  },
  {
    id: DefaultMetricOptions.HabitCompletion,
    name: {
      en: 'Habit completion',
      nl: 'Gewoontes voltooid',
    },
    description: {
      en: 'The average completion of the linked habits per week',
      nl: 'De gemiddelde voltooiing van de gekoppelde gewoontes per week',
    },
    descriptionShort: {
      en: '80% habit completion',
      nl: '80% gewoontes voltooid',
    },
    unitName: {
      en: 'Habit completion',
      nl: 'Gewoontes voltooid',
    },
  },
  {
    id: DefaultMetricOptions.SubTarget,
    name: {
      en: 'Sub target',
      nl: 'Tussendoel',
    },
    description: {
      en: 'A milestone towards the numeric target of a goal it contributes to',
      nl: 'Een tussenstap naar het numerieke doel van een doel waar het aan bijdraagt',
    },
    descriptionShort: {
      en: 'E.g. €25k of €100k',
      nl: 'Bijv. €25k van €100k',
    },
    unitName: {
      en: 'Unit',
      nl: 'Eenheid',
    },
  },
  {
    id: DefaultMetricOptions.Custom,
    name: {
      en: 'Custom',
      nl: 'Custom',
    },
    description: {
      en: 'Create your own metric',
      nl: 'Creëer je eigen metriek',
    },
    descriptionShort: {
      en: 'Create your own metric',
      nl: 'Creëer je eigen metric',
    },
    unitName: {
      en: 'Unit',
      nl: 'Eenheid',
    },
  },
];
